import { useState } from 'react'
import { Download, Loader2 } from 'lucide-react'
import { usePoints } from '@/modules/points/hooks/usePoints'
import { PointsTable } from '@/modules/points/components/PointsTable'
import { ErrorState } from '@/shared/components/ui/atoms/ErrorState'
import { Can } from '@/modules/auth/components/Can'
import { Permission } from '@/modules/auth/permissions/permissions'
import { pointService } from '@/modules/points/services/pointService'

export function PointsListPage() {
  const {
    data, total, isLoading, error, filters, hasActiveFilters,
    setPage, setLimit, setSorting, applyFilters,
    clearFilters, refetch,
  } = usePoints()

  const [isExporting, setIsExporting] = useState(false)

  const handleExport = async () => {
    setIsExporting(true)
    try {
      const exportFilters = { ...filters }
      delete (exportFilters as Record<string, unknown>).page
      delete (exportFilters as Record<string, unknown>).limit
      const blob = await pointService.exportAll(exportFilters)
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = `puntos_${new Date().toISOString().split('T')[0]}.xlsx`
      link.click()
      URL.revokeObjectURL(url)
    } catch (err) {
      console.error('Error exporting:', err)
    } finally {
      setIsExporting(false)
    }
  }

  return (
    <div>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">Historial de Puntos</h1>
          <p className="text-sm text-gray-500 mt-1">
            Para agregar una transacción de puntos, ve a la sección &quot;Clientes&quot;, busca al cliente por RUT y desde su ficha gestiona sus puntos.
          </p>
        </div>
        <div className="flex gap-2">
          <Can permission={Permission.POINTS_EXPORT}>
            <button
              onClick={handleExport}
              disabled={isExporting}
              className="btn btn-secondary flex items-center gap-1.5"
            >
              {isExporting ? <Loader2 size={16} className="animate-spin" /> : <Download size={16} />}
              {isExporting ? 'Exportando...' : hasActiveFilters ? 'Exportar (filtrado)' : 'Exportar'}
            </button>
          </Can>
        </div>
      </div>

      {error && <ErrorState message={error} onRetry={refetch} />}

      <div className="card">
        <PointsTable
          data={data}
          total={total}
          filters={filters}
          hasActiveFilters={hasActiveFilters}
          onPageChange={setPage}
          onLimitChange={setLimit}
          onApplyFilters={applyFilters}
          onSortingChange={setSorting}
          onClearFilters={clearFilters}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}
